import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Loader2, Plus } from "lucide-react";

const today = () => new Date().toISOString().slice(0, 10);

export const PcEntryDialog = ({ open, type, categories, onClose, onSaved }) => {
  const [f, setF] = useState({});
  const [newCat, setNewCat] = useState("");
  const [cats, setCats] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { const c = categories?.[type] || []; setCats(c); setF({ category: c[0] || "", amount: "", currency: "SAR", date: today(), description: "" }); setNewCat(""); }
  }, [open, type, categories]);
  const addCat = async () => {
    if (!newCat.trim()) return;
    try { const r = await api.pcAddCategory(type, newCat.trim()); setCats(r[type]); setF((x) => ({ ...x, category: newCat.trim() })); setNewCat(""); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر إضافة البند"); }
  };
  const save = async () => {
    if (!Number(f.amount)) { toast.error("أدخل المبلغ"); return; }
    setBusy(true);
    try { await api.pcAdd({ ...f, type, amount: Number(f.amount) }); toast.success("تم تسجيل القيد"); onSaved(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  const sel = "mt-1 h-10 w-full rounded-md border border-slate-200 bg-white px-2 text-sm";
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent dir="rtl" className="max-w-md font-body" data-testid="pc-entry-dialog">
        <DialogHeader className="text-right"><DialogTitle className="font-heading">{type === "income" ? "إضافة إيراد" : "إضافة مصروف"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">البند</Label>
            <select className={sel} value={f.category || ""} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="pc-entry-category">
              {cats.map((c) => <option key={c} value={c}>{c}</option>)}</select>
            <div className="mt-1.5 flex gap-1.5"><Input value={newCat} onChange={(e) => setNewCat(e.target.value)} placeholder="بند جديد" className="h-8 text-xs" data-testid="pc-new-category" />
              <Button type="button" size="sm" variant="outline" className="h-8" onClick={addCat} data-testid="pc-add-category"><Plus className="h-3.5 w-3.5" /></Button></div>
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-2"><Label className="text-xs">المبلغ</Label><Input type="number" value={f.amount || ""} onChange={(e) => setF({ ...f, amount: e.target.value })} className="mt-1" data-testid="pc-entry-amount" /></div>
            <div><Label className="text-xs">العملة</Label><select className={sel} value={f.currency} onChange={(e) => setF({ ...f, currency: e.target.value })} data-testid="pc-entry-currency">
              <option value="SAR">ر.س</option><option value="USD">USD</option><option value="EUR">EUR</option><option value="AED">AED</option></select></div>
          </div>
          <div><Label className="text-xs">التاريخ</Label><Input type="date" value={f.date || ""} onChange={(e) => setF({ ...f, date: e.target.value })} className="mt-1" data-testid="pc-entry-date" /></div>
          <div><Label className="text-xs">الوصف</Label><Input value={f.description || ""} onChange={(e) => setF({ ...f, description: e.target.value })} className="mt-1" data-testid="pc-entry-desc" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>إلغاء</Button>
          <Button onClick={save} disabled={busy} data-testid="pc-entry-save">{busy && <Loader2 className="me-1 h-4 w-4 animate-spin" />} حفظ</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
